import { computed } from 'vue';
import { IssueRecord } from '@/entities/issue/v2';
import { t } from '@/ui/i18n/i18n';
import { hasPermission, Permissions } from '@/ui/auth/auth';

export function useManageIssueModal() {
  const canSeeIssueButton = computed(
    () => hasPermission(Permissions.MANAGE_ALL_ISSUE) || hasPermission(Permissions.MANAGE_OWN_ISSUE),
  );

  const willEditIssues = (issues: IssueRecord[]) => issues.length > 0;

  const getTooltipMessage = (issues: IssueRecord[]) => willEditIssues(issues)
    ? t('issues.edit-view')
    : t('issues.create');

  const isButtonDisabled = (issues: IssueRecord[]) => {
    if (willEditIssues(issues)) {
      return !canSeeIssueButton.value;
    }

    return !hasPermission(Permissions.CREATE_ISSUE);
  };

  return {
    willEditIssues,
    getTooltipMessage,
    canSeeIssueButton,
    isButtonDisabled,
  };
}
